import React, {createContext} from 'react';
const SettingsContext = createContext(null);
export {SettingsContext};